import styled from 'styled-components';
import Select from '../../../../_shared/components/Select';
import Box from '../../../../_shared/components/Box';

export const StyledSelectSection = styled(Box.Column)`
  padding-bottom: 25px;
`;

export const StyledInputSection = styled(Box.Column)``;

export const StyledBody = styled.div`
  padding-bottom: 40px;
`;

export const StyledFormSection = styled(Box.Column)``;

export const StyledSelect = styled(Select)`
  select {
    margin-top: 7px;
    text-overflow: ellipsis;
    height: 36px;
    width: 268px;
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
    line-height: ${({ theme }) => theme.FONT_SIZES.BASE};
    padding-top: 0;
    padding-bottom: 0;
  }

  div {
    right: 208px;
    top: 22px;
  }
`;

export const StyledInput = styled.input`
  margin-top: 7px;
  width: 216px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  border-radius: 3px;
  padding: 12px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: ${({ theme }) => theme.FONT_SIZES.BASE};

  &:focus {
    outline: none;
  }
`;
